const adminRoutes = [
  {
    path: '/admin/other',
    sidebarName: 'Dashboard',
    navbarName: 'OtherPage',
    icon: 'user',
    default: true,
    hidden: true,
    permission: 'admin.other.view',
  },
  {
    title: 'User Management',
    fullTitle: 'User Management',
    icon: 'supervisor_account',
    titleIcon: true,
    path: '/admin/user-management',
    permission: 'user.view',
  },
  {
    title: 'Email Queue Monitoring',
    fullTitle: 'Email Queue Monitoring',
    icon: 'email',
    titleIcon: true,
    path: '/admin/email-queue-monitoring',
    permission: 'user.view',
  },
  {
    title: 'Dedicated IP',
    fullTitle: 'Dedicated IP',
    icon: 'security',
    titleIcon: true,
    path: '/admin/dedicated-ip',
  },
  {
    title: 'Domain Monitoring',
    fullTitle: 'Domain Monitoring',
    icon: 'domain',
    titleIcon: true,
    path: '/admin/domain-monitoring',
  },
  {
    title: 'Domain Warmup',
    fullTitle: 'Domain Warmup',
    icon: 'local_fire_department',
    titleIcon: true,
    path: '/admin/domain-warmup',
  },
  {
    title: 'IP Pool Mapping',
    fullTitle: 'IP Pool Mapping',
    icon: 'compare',
    titleIcon: true,
    path: '/admin/domain-receiver-provider-ip-mapping',
  },
  {
    title: 'Authorized Domains',
    fullTitle: 'Authorized Domains',
    icon: 'dns',
    titleIcon: true,
    path: '/admin/authorized-domains',
  },
  {
    title: 'SIB Domains',
    fullTitle: 'SIB Domains',
    icon: 'dns',
    titleIcon: true,
    path: '/admin/sib-domains',
  },
  {
    title: 'Purge Cache',
    fullTitle: 'Purge Redis Cache',
    icon: 'cleaning_services',
    titleIcon: true,
    path: '/admin/purge-redis-cache',
  },
  {
    title: 'Bug/Feature Reports',
    fullTitle: 'Bug/Feature Reports',
    icon: 'bug_report',
    titleIcon: true,
    path: '/admin/bug-feature-reports',
  },
];

export default adminRoutes;
